export default "__VITE_ASSET__wNilNBpo__"